// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/3825
import type { PAPEventGeneric } from "../base/event";
import type { DashSurface } from "../enums/dash_surface";
import type { DashActionSurface } from "../enums/dash_action_surface";
import type { ActionSurfaceComponent } from "../enums/action_surface_component";
import type { FeatureLine } from "../enums/feature_line";
import type { DestinationSurface } from "../enums/destination_surface";

// Event_name: 'click.back_to_destination_surface'
// Description: - Only show when the user has directly visited the Assistant from one of a pre-set number of locations:
// - Stack Detail - `Back to stack`
// - Search - `Back to search`
// - Feed - `Back to home`
// Owner: dash-web
export type Click_BackToDestinationSurface = PAPEventGeneric<
  'dash',
  'click',
  'back_to_destination_surface',
  {
    // Which Dash surface (web, desktop, or browser extension) the event originated from.
    dashSurface?: DashSurface;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // The component within a surface in which an action was taken on Dash.
    actionSurfaceComponent?: ActionSurfaceComponent;
    // Feature Line for dash
    featureLine?: FeatureLine;
    // The destination the entry point is heading to. This can be either in the multi-product or within Dropbox Core if it is embedded. Ideally, the surface names here should align with action surfaces on multi-products as much as possible.
    destinationSurface?: DestinationSurface;
  }
>;

export function PAP_Click_BackToDestinationSurface(properties?: Click_BackToDestinationSurface['properties']): Click_BackToDestinationSurface {
  return <Click_BackToDestinationSurface>{
    class: 'dash',
    action: 'click',
    object: 'back_to_destination_surface',
    properties,
  };
}
